<template>
  <div>
    <h2>Inicio de sesión</h2>
    <form @submit.prevent="login">
      <div>
        <label for="username">Nombre de usuario:</label>
        <input type="text" id="username" v-model="username">
      </div>
      <div>
        <label for="password">Contraseña:</label>
        <input type="password" id="password" v-model="password">
      </div>
      <button type="submit">Iniciar sesión</button>
    </form>
  </div>
</template>

<script>
import { login } from '../services/multiSnifferService'
export default {
  data () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    async login () {
      // Aquí puedes agregar la lógica para enviar los datos del formulario al servidor para autenticación
      console.log('Nombre de usuario:', this.username)
      console.log('Contraseña:', this.password)
      const res = await login(this.username, this.password)
      console.log(res)
      let token = res.data.token
      localStorage.setItem('token', token)
      this.$router.push('/')
      // También puedes agregar aquí la lógica para redirigir al usuario a otra página después del inicio de sesión exitoso
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login.vue